import campaignsReducer from './campaigns.slice'

export default campaignsReducer
